import Link from 'next/link';
import { Card, CardContent } from '@/components/shadcn/card';
import BeeAndTextIcon from '@/components/ui/icons/BeeAndTextIcon';
import BeeCameraIcon from '@/components/ui/icons/BeeCameraIcon';
import TrainersIcon from '@/components/ui/icons/trainers/TrainersIcon';
import { ExternalUrls } from '@/utils/url.ts';

export default function Contribute() {
  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-sm font-bold md:text-xl">Contribute</h2>
      <div className="flex flex-1 gap-4">
        <Link
          href={ExternalUrls.BeeDashcamStore}
          target="_blank"
          className="flex-1">
          <Card className="size-full flex-1 rounded border-transparent bg-neutral-900 transition-all hover:border-neutral-600 md:rounded-lg">
            <CardContent className="flex flex-col justify-between p-4">
              <div className="flex size-20 flex-col gap-2">
                <BeeAndTextIcon className="fill-neutral-0" />
                <BeeCameraIcon className="fill-neutral-0" />
              </div>
              <h4>Map With a Dashcam</h4>
            </CardContent>
          </Card>
        </Link>
        <Link href="/trainers" className="flex-1 ">
          <Card className="size-full flex-1 rounded border-transparent bg-neutral-900 transition-all hover:border-neutral-600 md:rounded-lg">
            <CardContent className="flex h-full flex-col justify-between p-4">
              <div className="flex size-12 flex-col gap-2">
                <TrainersIcon className="fill-neutral-0" />
              </div>
              <h4>Train the Map AI</h4>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  );
}
